import { jsxs as i, jsx as o } from "@emotion/react/jsx-runtime";
import { useState as m } from "react";
import { Stack as d, Text as h, Icon as g, FontAwesomeIconsPartooUsed as s, IconPrefix as y, Expandable as u, Filters as x } from "@partoohub/ui";
import { useDynamicFiltersContext as f } from "../../../DynamicFiltersContext.js";
import { DropdownContainer as C } from "../SelectableCheckboxCard/SelectableFilterView.styled.js";
import { resetFilter as k, updateRadio as F } from "../../../reducer/dynamicFilters.actions.js";
const w = ({
  filterMeta: e
}) => {
  const [r, p] = m(!0), {
    preFilters: c,
    dispatch: n
  } = f(), a = () => p((t) => !t), l = (t) => {
    Object.keys(t).length === 0 ? n(k({
      property: e.property
    })) : n(F({
      property: e.property,
      value: Object.keys(t)[0],
      checked: !0
    }));
  };
  return /* @__PURE__ */ i(d, { gap: "0", children: [
    /* @__PURE__ */ i(C, { onClick: a, children: [
      /* @__PURE__ */ o(h, { variant: "heading6", children: e.sectionName }),
      /* @__PURE__ */ o(g, { icon: [r ? s.faChevronDown : s.faChevronRight, y.SOLID] })
    ] }),
    /* @__PURE__ */ o(u, { opened: r, children: /* @__PURE__ */ o("div", { style: {
      marginTop: 16
    }, children: /* @__PURE__ */ o(x, { dataTrackId: "test", placeholder: e.sectionName, position: "bottom", menuListArray: [{
      options: e.options
    }], onChange: l, maxHeight: 200, multiple: !1, selectedItems: Object.fromEntries(c[e.property].entries()) }) }) })
  ] });
};
export {
  w as SingleSelectFilterView
};
